export default class Abstract {
  log(msg) {
    if (process.env.MIX_APP_ENV !== 'production') {
      console.log(msg)
    }
  }
}
